import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AdProvider } from './contexts/AdContext';
import { AdminProvider } from './contexts/AdminContext';
import { Layout } from './components/Layout/Layout';
import { Home } from './pages/Home';
import { Dashboard } from './pages/Dashboard';
import { UploadPage } from './pages/UploadPage';
import { StudyPage } from './pages/StudyPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DocumentsPage } from './pages/DocumentsPage';
import { ProgressPage } from './pages/ProgressPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { ProtectedAdminRoute } from './components/ProtectedAdminRoute';
import { PropellerAd } from './components/ads';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <AdProvider>
            <AdminProvider>
              <Router>
                <div className="App">
                  <PropellerAd style={{ display: 'none' }} />
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      duration: 4000,
                      style: {
                        background: 'var(--toast-bg)',
                        color: 'var(--toast-color)',
                      },
                    }}
                  />
                  
                  <Routes>
                    {/* Admin routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route 
                      path="/admin" 
                      element={
                        <ProtectedAdminRoute>
                          <AdminDashboard />
                        </ProtectedAdminRoute>
                      } 
                    />
                    
                    {/* Home page without sidebar */}
                    <Route path="/" element={<Layout showSidebar={false}><Home /></Layout>} />
                    
                    {/* App pages with sidebar */}
                    <Route 
                      path="/dashboard" 
                      element={
                        <Layout>
                          <ErrorBoundary>
                            <Dashboard />
                          </ErrorBoundary>
                        </Layout>
                      } 
                    />
                    <Route 
                      path="/upload" 
                      element={
                        <Layout>
                          <ErrorBoundary>
                            <UploadPage />
                          </ErrorBoundary>
                        </Layout>
                      } 
                    />
                    <Route 
                      path="/study" 
                      element={
                        <Layout>
                          <ErrorBoundary>
                            <StudyPage />
                          </ErrorBoundary>
                        </Layout>
                      } 
                    />
                    <Route 
                      path="/documents" 
                      element={
                        <Layout>
                          <ErrorBoundary>
                            <DocumentsPage />
                          </ErrorBoundary>
                        </Layout>
                      } 
                    />
                    <Route 
                      path="/progress" 
                      element={
                        <Layout>
                          <ErrorBoundary>
                            <ProgressPage />
                          </ErrorBoundary>
                        </Layout>
                      } 
                    />
                    
                    {/* Catch all route - redirect to dashboard */}
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </div>
              </Router>
            </AdminProvider>
          </AdProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;